import React from "react";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { colors, fontSize } from "style";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";

/**
 * ProfileFlag
 *
 * @param {number}  count
 * @param {boolean} hideFlagCount
 */
const ProfileFlag = ({ count, hideFlagCount, ...props }) => {
  if (isNaN(count) || count == 0) return null;

  return (
    <div css={styles.container} {...props}>
      <div css={styles.icon_container}>
        <Icon type={ICON_TYPE.filledFlagCut} size={ICON_SIZE.xlarge} color={colors.red} />
      </div>
      {!hideFlagCount && (
        <span>
          <FormattedMessage
            id="Profile.ProfileFlag.Title"
            values={{
              count: count > 1 ? `x${count}` : ``,
            }}
          />
        </span>
      )}
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0rem;
    color: ${colors.grayAnatomyLight1};
    font-size: ${fontSize.small};
    font-weight: 500;
  `,
  icon_container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3rem;
  `,
};

ProfileFlag.defaultProps = {
  hideFlagCount: false,
};

ProfileFlag.propTypes = {
  count: PropTypes.number.isRequired,
  hideFlagCount: PropTypes.bool,
};

export default ProfileFlag;
